// extracted by mini-css-extract-plugin
module.exports = {"link":"aut-header_link__YR1jw","header":"aut-header_header__p1yu4","section":"aut-header_section___5pgK"};